import { getFullName } from "@clockwise/web-commons/src/util/profile.util";
import { TradeoffAttendee } from "../../chat/ai-chat/utils/types";
import { EventCardAttendee } from "../types";

const fullName = (attendee: TradeoffAttendee | EventCardAttendee) => {
  const fullName = getFullName(attendee.profile);
  const defaultAttendeeName = Object.hasOwn(attendee, "primaryCalendarId")
    ? (attendee as TradeoffAttendee).primaryCalendarId
    : (attendee as EventCardAttendee).primaryCalendar;

  return fullName || defaultAttendeeName;
};

export const getStringListOfAttendees = (attendees: TradeoffAttendee[] | EventCardAttendee[]) => {
  const numAttendees = attendees.length;

  const attendeeNameList = attendees
    .map((attendee, index) => {
      const baseName = attendee.isYou ? "You" : fullName(attendee);
      if (index === numAttendees - 2) {
        return baseName + " and";
      }
      if (index === numAttendees - 1) {
        return baseName;
      }
      return baseName + ",";
    })
    .join(" ");

  return attendeeNameList;
};
